import React from "react";
import { Link } from "react-router-dom";
import PolicyLayout, { PolicySection } from "../components/PolicyLayout";

const SECTIONS = [
  { id: "age-warning",  label: "Age Warning"         },
  { id: "prop65",       label: "CA Prop 65"           },
  { id: "tobacco",      label: "Tobacco & Vaping"     },
  { id: "kratom",       label: "Kratom"               },
  { id: "delta",        label: "Delta & Hemp"         },
  { id: "general",      label: "General Disclaimer"   },
  { id: "liability",    label: "Liability"            },
  { id: "regulatory",   label: "Regulatory"           },
  { id: "contact",      label: "Contact"              },
];

export default function Disclaimers() {
  return (
    <PolicyLayout
      title="Disclaimers"
      description="Important disclaimers regarding age restrictions, product compliance, health warnings, and limitations of liability for Khoja Distributions wholesale products."
      canonical="https://www.khojadistributions.com/disclaimer"
      sections={SECTIONS}
      relatedLinks={
        <>
          <Link to="/terms" className="text-sm text-accent font-bold hover:underline">Terms & Conditions</Link>
          <Link to="/privacy-policy" className="text-sm text-accent font-bold hover:underline">Privacy Policy</Link>
          <Link to="/return" className="text-sm text-accent font-bold hover:underline">Return Policy</Link>
        </>
      }
    >
      {/* Age warning — uses the warning variant for red styling */}
      <PolicySection id="age-warning" title="⚠ Age Restriction Warning" variant="warning">
        <p><strong>NOT FOR SALE TO MINORS.</strong> The products sold through Khoja Distributions are intended for adult use only by persons 21 years of age or older. It is the sole responsibility of the purchasing retailer to comply with all applicable federal, state, and local age verification laws at the point of sale.</p>
      </PolicySection>

      <PolicySection id="prop65" title="California Proposition 65 Warning">
        <p><strong>WARNING:</strong> This product contains nicotine, a chemical known to the State of California to cause birth defects or other reproductive harm. Nicotine is addictive.</p>
        <p>This warning applies to tobacco products, disposable vaping devices, e-liquids, and related products sold through Khoja Distributions.</p>
      </PolicySection>

      <PolicySection id="tobacco" title="Tobacco & Vaping Products">
        <p>Tobacco products and electronic nicotine delivery systems (ENDS), including disposable vapes and e-cigarettes, are sold strictly for adult use. These products contain nicotine, which is highly addictive and harmful to health.</p>
        <p>Khoja Distributions does not make any health claims regarding tobacco or vaping products. These products are not intended to diagnose, treat, cure, or prevent any disease or health condition.</p>
        <p>Retailers are responsible for displaying all required health warning labels in accordance with federal and state law, including the FDA's required nicotine addiction warning.</p>
      </PolicySection>

      <PolicySection id="kratom" title="Kratom Products">
        <p>Kratom products are sold as botanical products and are not evaluated or approved by the Food and Drug Administration (FDA). Kratom is not intended to diagnose, treat, cure, or prevent any disease.</p>
        <p>The legal status of kratom varies by state and locality. It is the purchasing retailer's sole responsibility to verify that the sale and possession of kratom is lawful in their jurisdiction before placing an order.</p>
        <p>Keep out of reach of children. Not for use by pregnant or nursing women.</p>
      </PolicySection>

      <PolicySection id="delta" title="Delta & Hemp-Derived Products">
        <p>Delta-8, Delta-9, and other hemp-derived cannabinoid products sold through Khoja Distributions are derived from hemp containing less than 0.3% Delta-9 THC on a dry weight basis, consistent with the 2018 Farm Bill.</p>
        <p>These products have not been evaluated by the FDA. They are not intended to diagnose, treat, cure, or prevent any disease. Individual state laws regarding hemp-derived cannabinoids vary and are subject to change. Retailers are responsible for compliance with all applicable laws in their jurisdiction.</p>
        <p>Not for sale to minors. Keep out of reach of children and pets.</p>
      </PolicySection>

      <PolicySection id="general" title="General Product Disclaimer">
        <p>Khoja Distributions acts as a wholesale distributor and does not manufacture the products sold on this platform. All product descriptions, specifications, and representations are provided by the manufacturers and are subject to change without notice.</p>
        <p>Khoja Distributions makes no warranty, express or implied, regarding the fitness, merchantability, or safety of any product for any specific purpose. Retailers assume all responsibility for the safe and lawful sale of products to end consumers.</p>
      </PolicySection>

      <PolicySection id="liability" title="Limitation of Liability">
        <p>To the fullest extent permitted by applicable law, Khoja Distributions shall not be liable for any damages, losses, or claims arising from the misuse, unlawful sale, or improper storage of products purchased through our platform.</p>
        <p>Our total liability for any claim shall not exceed the purchase price of the specific product giving rise to the claim.</p>
      </PolicySection>

      <PolicySection id="regulatory" title="Regulatory Compliance">
        <p>It is the sole responsibility of the retailer to obtain all required business licenses, permits, and regulatory approvals necessary to sell the products purchased from Khoja Distributions in their jurisdiction. This includes but is not limited to tobacco retailer licenses, age verification procedures, and any state or local permits required for the sale of hemp-derived products.</p>
      </PolicySection>

      <PolicySection id="contact" title="Contact">
        <p>For questions regarding these disclaimers or the products we carry:</p>
        <p>
          <strong>Khoja Distributions</strong><br />
          Phone: <a href="tel:2146356340" className="text-accent hover:underline">(214) 635-6340</a><br />
          Email: <a href="mailto:khojadistributions@gmail.com" className="text-accent hover:underline">khojadistributions@gmail.com</a>
        </p>
      </PolicySection>
    </PolicyLayout>
  );
}
